module.exports = __webpack_public_path__ + "img/xuyiran.6ea7d201.png";